import type { ConnectedPosition } from '@angular/cdk/overlay';

type Side = 'top' | 'bottom';
type Align = 'start' | 'end';

const OPPOSITE_SIDE: Record<Side, Side> = { top: 'bottom', bottom: 'top' };
const OPPOSITE_ALIGN: Record<Align, Align> = { start: 'end', end: 'start' };

function position(side: Side, align: Align, offsetY: number): ConnectedPosition {
  return { originX: align, originY: side, overlayX: align, overlayY: OPPOSITE_SIDE[side], offsetY };
}

export function connectedPositions(side: Side, align: Align, offset: number): ConnectedPosition[] {
  const sign = side === 'bottom' ? 1 : -1;
  return [
    position(side, align, sign * offset),
    position(side, OPPOSITE_ALIGN[align], sign * offset),
    position(OPPOSITE_SIDE[side], align, -sign * offset),
    position(OPPOSITE_SIDE[side], OPPOSITE_ALIGN[align], -sign * offset),
  ];
}
